var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v(_vm._s(_vm.module.title))]),_c('card-tags',{staticStyle:{"margin-bottom":"10px"},attrs:{"module":_vm.module},on:{"showTaggedModules":_vm.showTaggedModules}}),_c('p',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.module.contents.longDescription)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }